import React from 'react';
import './HomeHero.css';
import heroBg from '../../../assets/Home/Hero.jpg';
const HomeHero = () => {
  return (
    <section className="hh-hero">

      {/* ── Real <img> background — no CSS url() hack ── */}
      <div className="hh-bg">
        <img
          src={heroBg}
          alt=""
          aria-hidden="true"
          className="hh-bg-img"
        />
        <div className="hh-overlay"></div>
      </div>

      {/* ── Content ── */}
      <div className="hh-container">
        <div className="hh-center">

          <div className="hh-eyebrow">
            <span className="hh-dot"></span>
            Medical College Establishment &amp; Institutional Advisory
          </div>

          <h1 className="hh-title">
            From Concept to{' '}
            <span className="hh-gradient">Institutional Readiness</span>
          </h1>

          <div className="hh-tags" aria-label="Core service keywords">
            <span>Strategic Advisory</span>
            <span>Institutional Planning</span>
            <span>Academic Expansion</span>
            <span>Documentation</span>
            <span>Readiness</span>
            <span>Medical Faculty Solutions</span>
          </div>

          <p className="hh-desc">
            Nutrivio Medical Services Private Limited provides structured professional advisory and institutional support to organisations, Medical Colleges and Teaching Hospitals for the establishment, expansion and strengthening of medical education institutions.
          </p>

          <div className="hh-actions">
            <a href="/for-institutions" className="hh-btn-primary">
              <span>Discuss Your Project</span>
            </a>
            <a href="#services" className="hh-btn-secondary">
              Explore Our Services
            </a>
            <a href="/for-medical-faculty" className="hh-btn-tertiary">
              Request Medical Faculty
            </a>
          </div>

          <div className="hh-trust">
            <span className="hh-trust-item"><span className="hh-check">✓</span> Greenfield to Expansion</span>
            <span className="hh-sep">•</span>
            <span className="hh-trust-item"><span className="hh-check">✓</span> 100% Verified Faculty</span>
            <span className="hh-sep">•</span>
            <span className="hh-trust-item"><span className="hh-check">✓</span> Pan-India Scope</span>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HomeHero;
